import type { Configuration } from '@azure/msal-browser'

const clientId = import.meta.env.VITE_AAD_CLIENT_ID
const tenantId = import.meta.env.VITE_AAD_TENANT_ID
const apiUri = import.meta.env.VITE_APP_URI

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
}

/** Delegated scope exposed by this same app registration under "Expose an API" — see infra/README.md */
export const apiTokenScopes = [`${apiUri}/access_as_user`]
